"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/* Captured From PROD at http://localhost:3000/en/cars */
var DEFAULT_PROPS = {
  id: 'language-masters_en_1543348838519',
  resourceType: 'EditorialCards_1_0_0',
  lastModified: '1543348838519',
  editorialLayout: 'large',
  columns: [],
  __typename: 'Editorial'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;